import config from '@/config';
import axios from 'axios';
import { castOutVariable } from '@/utils/variables';


function sendAction(varItem) {
  const url = new URL(
    config.ICOOL.API.ACTION_PATH(varItem.snapshotId), config.ICOOL.BACKEND_HOST
  ).href;
  const data = {
    varItemId: varItem.id,
    value: castOutVariable(varItem.value, varItem.type),
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then((response) => {
        resolve();
      })
      .catch((error) => {
        console.log(error);
        reject();
      })
      .finally(() => {
      });
  });
}

export default sendAction;
